import React, { useState, useEffect } from "react";
import { Tabs } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import About from "./About";
import WorkExperience from "./WorkExperience";
import Projects from "./Projects";
import "./ProfileTabs.css";
const { TabPane } = Tabs;

function ProfileTabs() {
  const [activeTab, setActiveTab] = useState("1");
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkIfMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    checkIfMobile();
    window.addEventListener('resize', checkIfMobile);

    return () => {
      window.removeEventListener('resize', checkIfMobile);
    };
  }, []);

  const handleTabChange = (key) => {
    setActiveTab(key);
  };

  return (
    <div className="profile-tabs-container">
      <Tabs activeKey={activeTab} onChange={handleTabChange}>
        <TabPane
          tab={
            <span>
              <FontAwesomeIcon icon="fa-solid fa-user" /> {!isMobile && "ABOUT & SKILLS"}
            </span>
          }
          key="1"
        >
          <div className="tab-content">
            <About />
          </div>
        </TabPane>
        <TabPane
          tab={
            <span>
              <FontAwesomeIcon icon="fa-solid fa-briefcase" /> {!isMobile && "WORK EXPERIENCE"}
            </span>
          }
          key="2"
        >
          <div className="tab-content">
            <WorkExperience />
          </div>
        </TabPane>
        <TabPane
          tab={
            <span>
              <FontAwesomeIcon icon="fa-solid fa-code" /> {!isMobile && "PROJECTS"}
            </span>
          }
          key="3"
        >
          <div className="tab-content">
            <Projects />
          </div>
        </TabPane>
      </Tabs>
    </div>
  );
}

export default ProfileTabs;